import { debounce, throttle } from './_helpers'
import GoogleMap from './GoogleMap'

const setWrapperHeight = (wrapper, activeTab) => {
  const tabHeight = activeTab.clientHeight

  if (!tabHeight) {
    return
  }

  wrapper.style.height = `${tabHeight}px`
}

export default function initTabs(
  el,
  page,
  callback = null,
  eventListenersRemover
) {
  // using ID allows to control multiple content blocks by same set of buttons
  const internalId = el.dataset.tabs
  const tabButtons = el.querySelectorAll(
    `[data-tab-button][data-tab-id*="${internalId}"]`
  )
  const tabContent = el.querySelectorAll(
    `[data-tab-content][data-tab-id*="${internalId}"]`
  )
  const tabContentWrapper = el.querySelector(
    `[data-tab-wrapper][data-tab-id*="${internalId}"]`
  )
  const tabContentImages = []
  const map = page.querySelector(`[data-tab-map='${el.dataset.tabs}']`)
  const googleMap = map && new GoogleMap(map)
  if (!tabButtons || !tabContent || !tabContentWrapper) {
    return
  }

  let activeTab = tabContent[0]

  tabContent.forEach(tab => {
    const tabImages = tab.querySelectorAll('img')

    tabImages.forEach(img => tabContentImages.push(img))
  })

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      tabButtons.forEach(button => {
        if (button.classList.contains('active')) {
          button.classList.remove('active')
        }
      })

      tabContent.forEach(tab => {
        tab.removeAttribute('data-tab-active')
      })

      btn.classList.add('active')

      activeTab = Array.from(tabContent).find(
        tab => tab.dataset.tabContent === btn.dataset.tabButton
      )

      activeTab.setAttribute('data-tab-active', '')
      setWrapperHeight(tabContentWrapper, activeTab)

      const activeTabName = activeTab.dataset.tabContent

      if (callback) {
        callback(activeTab)
      }

      if (googleMap) {
        fetch(`${map.dataset.coordinatesRoute}/${activeTabName}`)
          .then(res => res.json())
          .then(json => googleMap.setMarkers(json))
      }
    })
  })

  const throttledSetTabContentHeight = throttle(() => {
    setWrapperHeight(tabContentWrapper, activeTab)
  }, 300)

  const debouncedSetTabContentHeight = debounce(() => {
    setWrapperHeight(tabContentWrapper, activeTab)
  }, 300)

  const mutationObserver = new MutationObserver(mutations =>
    mutations.forEach(() => {
      debouncedSetTabContentHeight()
    })
  )

  mutationObserver.observe(tabContentWrapper, {
    childList: true,
    subtree: true,
  })

  const disconnectMutationObserver = () => mutationObserver.disconnect()

  window.addEventListener('resize', throttledSetTabContentHeight)
  window.addEventListener('containerLoad', disconnectMutationObserver)
  if (tabContentImages)
    tabContentImages.forEach(img =>
      img.addEventListener('load', debouncedSetTabContentHeight, { once: true })
    )

  eventListenersRemover.push(
    {
      el: window,
      event: 'resize',
      func: throttledSetTabContentHeight,
    },
    {
      el: window,
      event: 'containerLoad',
      func: disconnectMutationObserver,
    }
  )

  tabButtons.forEach(b => {
    if (b.hasAttribute('data-first-active')) {
      b.click()
    }
  })
}
